import React from "react";
import Headline from "../../components/Headline";
import { MainLayout } from "../../components/Layout";
import LinkButton from "../../components/LinkButton";
import { URL_PATHS } from "../../routes";
import { oneLink } from "../../shared/oneLink";
import AnchorButton from "../../components/AnchorButton";
import "./styles.scss";

interface TransitionFinishProps {
    isWaitingToSwitchToCardPayment: boolean;
}
const TransitionFinish = (props: TransitionFinishProps) => {
    const description = () => {
        return props.isWaitingToSwitchToCardPayment ? (
            <>
                クレジットカード決済へ移行しました。
                <br />
                次回の自動更新日より適用されます。
                <br />
                自動更新日（決済開始予定日）はマイページの
                <br />
                「決済情報を確認」から確認できます。
            </>
        ) : (
            <>
                クレジットカード決済へ移行しました。
                <br />
                新しい機能がすでにお使いいただけます。
                <br />
                また次回更新日はマイページの
                <br />
                「決済情報を確認」から確認できます。
            </>
        );
    };
    return (
        <MainLayout>
            <Headline>
                クレジットカード決済へ
                <br />
                移行完了
            </Headline>
            <section className="transition-finish">
                <p className="finish-message">{description()}</p>

                <div className="user-action">
                    <AnchorButton href={oneLink()}>アプリを開く</AnchorButton>
                    <LinkButton color="secondary" to={URL_PATHS.myPage()}>
                        マイページへ
                    </LinkButton>
                </div>
            </section>
        </MainLayout>
    );
};

export default TransitionFinish;
